import service from "./service";
import { DataResponse } from "../types/api";
import { ResourcePermission } from "../types/uam";

const prefix = "/common-uam";

export const postRelatedResource = (
  userId: string,
  parentName = "operate_event_manager"
): Promise<DataResponse<ResourcePermission[]>> =>
  service.post(`${prefix}/resources/specified/related-list`, {
    userId,
    parentName,
  });

